import { useTranslation } from "react-i18next";
import { BRANCH_TABS } from "./tabPanels";
import { BRANCH_TAB_META } from "./tabColors";

// شريط تبويبات ملوّن ثلاثي الأبعاد — نفس أسلوب بلاطات الرئيسية (3 صفوف على الموبايل، 4 على الديسكتوب).
export const BranchTabs = ({ tab, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="mb-6 grid grid-cols-3 gap-2 sm:grid-cols-4 lg:grid-cols-6" data-testid="branch-tabs">
      {BRANCH_TABS.map((key, i) => {
        const { icon: Icon, color } = BRANCH_TAB_META[key] || {};
        const active = tab === key;
        return (
          <button
            key={key} type="button" data-testid={`branch-tab-${key}`}
            onClick={() => onChange(key)}
            style={{ animationDelay: `${i * 30}ms` }}
            className={`group animate-rise-in flex flex-col items-center gap-1.5 rounded-3xl bg-background px-1.5 py-3 transition-[box-shadow,transform] duration-300 hover:-translate-y-0.5 ${
              active ? "shadow-neu-in text-primary" : "shadow-neu-sm hover:shadow-neu text-foreground"
            }`}
          >
            {Icon ? (
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-white shadow-neu-sm ${color}`}>
                <Icon className="h-5 w-5" strokeWidth={2.4} />
              </span>
            ) : null}
            <span className="w-full truncate text-center text-[11px] font-bold leading-tight">
              {t(`branches.tab.${key}`)}
            </span>
          </button>
        );
      })}
    </div>
  );
};
